import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DCard from "../../components/card/DCard";
import DCardHeader from "../../components/card/DCardHeader";
import DCardBody from "../../components/card/DCardBody";
import Select from "react-select";
import InputMask from "react-input-mask";
import { Table } from "react-bootstrap";

import { medicationTypes } from "../../../enum/enums";

const AntiarrhythmicMedicationCard = props => {
    const {
        children,
        className,
        //
        onRequestAdd,
        antiarrhythmicMedicationsListParm,
        ...attributes
    } = props;

    const [antiarrhythmicMedicationsList, setAntiarrhythmicMedicationsList] = useState(antiarrhythmicMedicationsListParm);
    const [type, setType] = useState(null);
    const [dose, setDose] = useState("");
    const [time, setTime] = useState("");
    const [description, setDescription] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [idRowEditing, setIdRowEditing] = useState(undefined);

    useEffect(() => {
        setAntiarrhythmicMedicationsList(antiarrhythmicMedicationsListParm);
    }, [antiarrhythmicMedicationsListParm]);

    function handleAddAntiarrhythmicMedication() {
        if (!isEditing) {
            const newAntiarrhythmicMedicationItem = {
                id: (Math.floor(Math.random() * 65536)).toString(),
                type,
                dose,
                time,
                description
            };

            const newAntiarrhythmicMedicationsList = [...antiarrhythmicMedicationsList, newAntiarrhythmicMedicationItem];
            setAntiarrhythmicMedicationsList(newAntiarrhythmicMedicationsList);
            onRequestAdd(newAntiarrhythmicMedicationsList);
        } else {
            const newAntiarrhythmicMedicationsList = antiarrhythmicMedicationsList.map(antiarrhythmicMedicationItem => {
                if (antiarrhythmicMedicationItem.id === idRowEditing) {
                    return {
                        id: antiarrhythmicMedicationItem.id,
                        type,
                        dose,
                        time,
                        description
                    }
                }

                return antiarrhythmicMedicationItem;
            })
            setAntiarrhythmicMedicationsList(newAntiarrhythmicMedicationsList);
            onRequestAdd(newAntiarrhythmicMedicationsList);
        }

        resetFields();
    }

    function handleEditAntiarrhythmicMedication(id) {
        const editRowInfo = antiarrhythmicMedicationsList.find(x => x.id === id);
        if (editRowInfo) {
            setType(editRowInfo.type);
            setDose(editRowInfo.dose);
            setTime(editRowInfo.time);
            setDescription(editRowInfo.description);

            setIdRowEditing(id);
            setIsEditing(true);
        }
    }

    function handleDeleteAntiarrhythmicMedications(id) {
        const newAntiarrhythmicMedicationsList = antiarrhythmicMedicationsList.filter(x => x.id !== id);
        setAntiarrhythmicMedicationsList(newAntiarrhythmicMedicationsList);
        onRequestAdd(newAntiarrhythmicMedicationsList);
    }

    function resetFields() {
        setType(null);
        setDose("");
        setTime("");
        setDescription("");

        setIsEditing(false);
        setIdRowEditing(undefined);
    }

    return (
        <>
            <DCard borderColor="light">
                <DCardHeader color="light" textColor="dark">Antiarrítmica</DCardHeader>
                <DCardBody>
                    <div className="basic-form">
                        <div className="row">
                            <div className="form-group mb-3 col-md-3">
                                <label>Antiarrítmica</label>
                                <Select
                                    isClearable
                                    defaultValue={type}
                                    value={type}
                                    onChange={(e) => setType(e)}
                                    options={medicationTypes}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            height: 45,
                                            backgroundColor: state.isDisabled ? "#dde0e3" : ""
                                        }),
                                    }}
                                    placeholder="Selecione..."
                                />
                            </div>
                            <div className="form-group mb-3 col-md-1">
                                <label>Dose</label>
                                <InputMask
                                    mask="99"
                                    maskChar=" "
                                    value={dose}
                                    onChange={(event) => {
                                        setDose(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <label>Tempo</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={time}
                                    onChange={e => setTime(e.target.value)}
                                />
                            </div>
                            <div className="form-group mb-3 col-md-4">
                                <label>Descrição</label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    value={description}
                                    onChange={e => setDescription(e.target.value)}
                                />
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <button className="btn btn-primary shadow mt-4 ms-1" onClick={handleAddAntiarrhythmicMedication}>
                                    <i className="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group mb-3 col-md-12" hidden={antiarrhythmicMedicationsList.length === 0}>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                <strong>Antiarrítmica</strong>
                                            </th>
                                            <th>
                                                <strong>Dose</strong>
                                            </th>
                                            <th>
                                                <strong>Tempo</strong>
                                            </th>
                                            <th>
                                                <strong>Descrição</strong>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            antiarrhythmicMedicationsList.map((antiarrhythmicMedicationItem) => {
                                                return (
                                                    <tr key={antiarrhythmicMedicationItem.id}>
                                                        <td>{antiarrhythmicMedicationItem.type.label}</td>
                                                        <td>{antiarrhythmicMedicationItem.dose}</td>
                                                        <td>{antiarrhythmicMedicationItem.time}</td>
                                                        <td>{antiarrhythmicMedicationItem.description}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    className="btn btn-info shadow sharp ms-1"
                                                                    onClick={() => handleEditAntiarrhythmicMedication(antiarrhythmicMedicationItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-danger shadow sharp ms-1"
                                                                    onClick={() => handleDeleteAntiarrhythmicMedications(antiarrhythmicMedicationItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </DCardBody>
            </DCard>
        </>
    )
}

AntiarrhythmicMedicationCard.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    //
    innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

AntiarrhythmicMedicationCard.defaultProps = {
    antiarrhythmicMedicationsListParm: []
};

export default AntiarrhythmicMedicationCard;